<template>
  <div class="is-flex is-justify-content-center is-align-items-center min-height-400">
    <button v-if="hideTimingForm" @click="showTimingForm" dir="rtl" class="button is-info">קבע מועד חדש ל- Follow Up</button>
    <div v-else class="is-flex is-flex-direction-column">
      <Snooze v-model="selectedTiming" :selected_date="selectedTiming"></Snooze>
      <a @click="changeTiming" class="button is-info mt-3" :class="{ 'is-loading': isChangingTiming }">
        Submit
      </a>
    </div>
  </div>
</template>

<script>
import Snooze from '@/components/Snooze'

export default {
  name: 'FeedAlertNoResponse',
  components: {
    Snooze
  },
  props: {
    alert: {
      type: Object,
      required: true
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      hideTimingForm: true,
      selectedTiming: null,
      isChangingTiming: false,
      alerts: []
    }
  },
  methods: {
    showTimingForm () {
      this.hideTimingForm = false
    },
    getResourceId () {
      return ['Offer', 'Position'].includes(this.alert.resource_type) ? this.alert.id : this.alert.resource_id
    },
    async getAlerts () {
      try {
        await this.$network_utils.getResourceAlerts({ resource_type: this.alert.resource_type, resource_id: this.getResourceId(), statuses: 'active,in_progress', sort: '-timing' }).then(response => {
          this.is_loading = false
          this.alerts = response
        })
      } catch {
        console.log('Cant get aplicant alerts')
      }
    },
    async changeTiming () {
      if (this.selectedTiming == undefined) {
        this.$utils.emit('show_toast', { text: 'תאריך לא בחור' })
        return
      }
      await this.getAlerts()
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: `All Alerts Changed Timing To <b>${new Date(this.selectedTiming).toLocaleString()}</b>`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 4,
        resource_type: this.alert.resource_type,
        resource_id: this.getResourceId()
      })
      let requests = []
      this.alerts.forEach(alert => {
        requests.push(this.$network_utils.updateAlert({ id: alert.id, timing: this.selectedTiming }))
      })
      const applicantAlerts = await this.$network_utils.getAllAlerts({ owner: this.$utils.getOwner().name, statuses: 'in_progress' })
      applicantAlerts.forEach(alert => {
        requests.push(this.$network_utils.updateAlert({ id: alert.id, status: 'active', owner: 'NULL', timing: this.selectedTiming }))
      })
      this.isChangingTiming = true
      await this.$caller.axios.all(requests).then(() => {
        this.isChangingTiming = false
        this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
      })
      this.onSubmit(this.$attrs.payload.modal_id)
    }
  }
}
</script>
